import { faGift, faMagnifyingGlass, faThumbsUp } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import step_1 from '../../assets/images/Steps-1.jpg';
import step_2 from '../../assets/images/Steps-2.jpg';
import './FabricWorks.css';

const FabricWorks = () => {
  const steps = [
    {
      stepTitle: 'STEP 01',
      stepHeading: 'Explore fabrics',
      stepDescription: 'Tons of unique fabric in diverse color options, with new items arriving every day.',
      icon: faMagnifyingGlass,
      search: 'Search Fabrics',
    },
    {
      stepTitle: 'STEP 02',
      stepHeading: 'Order sample',
      stepDescription: 'Get free swatches will all color options to feel the fabric. Order sample yardages to try them out.',
      icon: faGift,
    },
    {
      stepTitle: 'STEP 03',
      stepHeading: 'Manage orders',
      stepDescription: 'From order to delivery, every step is transparent and easily traced on the website.',
      icon: faThumbsUp,
    },
  ]

  const details_card = [
    {
      title: 'Search the right fabrics',
      description: 'Easy search for any kind of fabrics you want to buy. Add them to your enquiry list. Place sample order instantly',
      img: step_1,
    },
    {
      title: 'Curate as per your requirement',
      description: 'Send your tech pack. share your requirements to the service team. Get your preferred, custom fabric ordered',
      img: step_2,
    },

  ]
  return (
    <div className="fabric-container">
      <div className='fabric-works-content' data-aos='zoom-in'>
        <h3 className="fabric-works-title">How it works</h3>
        <h2 className="fabric-works-heading">Easy steps to sourcing</h2>
        <p className="fabric-works-description">Our seamless process ensures you get the highest quality fabrics, tailored to your needs, delivered on time - every time. Focus on what you do best, while we handle the rest.</p>
      </div>
      <div className='fabric-works-steps'>
        <div className="steps">
          {
            steps.map((step,index) => (
              <div key={step.stepTitle || index} className="step" data-aos="zoom-in-down">
                <h5 className="step-title" >{step.stepTitle}</h5>
                <FontAwesomeIcon className='step-icon' icon={step.icon} />
                <h3 className="step-heading">{step.stepHeading}</h3>
                <p className="step-description">{step.stepDescription}</p>
                <a href="#!" className="step-link">{step.search}</a>
                <hr />
              </div>
            ))
          }
        </div>
        <div className="details">
          {
            details_card.map((card,index) => (
              <div key={card.title || index} className="detail-box" data-aos='fade-down'>
                <h4 className="detail-title" >{card.title}</h4>
                <span className="detail-description">{card.description}</span>
                <div className='img-container'>
                  <img className='step_img' src={`${card.img}?time=${Date.now()}`} alt={card.img} />
                </div>
              </div>
            ))
          }
        </div>
      </div>
    </div>
  )
}

export default FabricWorks
